module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-4.4b50ff36.svg";